// src/client.ts
import { feathers } from "@feathersjs/feathers";
import authenticationClient from "@feathersjs/authentication-client";

// src/services/moca-web-hook/moca-web-hook.shared.ts
var mocaWebHookPath = "/integration/v1/moca-web-hook";
var mocaWebHookMethods = [
  "create"
];
var mocaWebHookClient = (client) => {
  const connection = client.get("connection");
  client.use(mocaWebHookPath, connection.service(mocaWebHookPath), {
    methods: mocaWebHookMethods
  });
};

// src/services/client-config/client-config.shared.ts
var clientConfigPath = "/integration/v1/client-config";
var clientConfigMethods = [
  "get"
];
var clientConfigClient = (client) => {
  const connection = client.get("connection");
  client.use(clientConfigPath, connection.service(clientConfigPath), {
    methods: clientConfigMethods
  });
};

// src/client.ts
var createClient = (connection, authenticationOptions = {}) => {
  const client = feathers();
  client.configure(connection);
  client.configure(authenticationClient(authenticationOptions));
  client.set("connection", connection);
  client.configure(mocaWebHookClient);
  client.configure(clientConfigClient);
  return client;
};
export {
  createClient
};
//# sourceMappingURL=client.js.map